import { InfoCircleFilled } from '@ant-design/icons';
import { CardProps, Col, Image, Row, Tooltip } from 'antd';

import Card from '../Card';
import styles from './JobBoardCard.module.css';

interface JobBoardCardProps extends CardProps {
  tooltipTitle?: string;
  logoSrc: string;
  logoAlt: string;
  extra?: React.ReactNode;
}

const JobBoardCard: React.FC<JobBoardCardProps> = ({
  tooltipTitle,
  logoSrc,
  logoAlt,
  children,
  extra,
  ...props
}) => {
  return (
    <Card
      className={[
        styles.cardExtraWithoutPaddingBottom,
        styles.bodyStyle,
        styles.headStyle,
        styles.card,
      ].join(' ')}
      extra={
        <Row gutter={8}>
          {Array.isArray(extra) ? extra.map((item) => <Col>{item}</Col>) : <Col>{extra}</Col>}
          <Col>
            <Tooltip title={tooltipTitle}>
              <InfoCircleFilled />
            </Tooltip>
          </Col>
        </Row>
      }
      {...props}
    >
      <Row className={styles.limitedWidthRow} gutter={[0, 16]}>
        <Col span={24}>
          <Row className={styles.limitedRow} align="middle">
            <Image src={logoSrc} preview={false} className={styles.image} alt={logoAlt} />
          </Row>
        </Col>
        <Col span={24}>
          <Row align="middle" justify="center">
            {children}
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default JobBoardCard;
